module.exports = __webpack_public_path__ + "img/SERVICIO-COURIER-1.4e94f18b.png";